import { Country } from '@/constants/countries-phones';

import { findCountryByIso2 } from './find-country-by-iso2';

export const detectBrowserCountry = (): Country | undefined => {
  if (typeof navigator === 'undefined') return undefined;

  const languages = [navigator.language, ...(navigator.languages || [])];

  for (const lang of languages) {
    if (!lang) continue;
    const parts = lang.split(/[-_]/);
    if (parts.length < 2) continue;
    const countryCode = parts[parts.length - 1];
    if (countryCode.length !== 2) continue;
    const country = findCountryByIso2(countryCode);
    if (country) return country;
  }

  return undefined;
};
